import { connect } from "react-redux"
import React, { Component } from 'react';
import './Common.css';
import './Summary.css';
import { betStatusFromDatabase, changeTextInput, viewProposalLoadAndNav, getBetSummary, updateEthPrice } from "../actions/betActions"
import SummaryCard from './SummaryCard';
import loading from '../loading2.gif';

const stateMap = (store) => {
    return {
        textInputData: store.bet.textInputData,
        pageContext: store.bet.pageContext,
        authentication: store.bet.authentication,
        ethPrice: store.bet.ethPrice,
        blockchainDataMap: store.bet.blockchainDataMap
    };
};
class Summary extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.changeTextInput = this.changeTextInput.bind(this);
        this.viewProposal = this.viewProposal.bind(this);
        this.getContext = this.getContext.bind(this);
    }

    componentDidMount() {

        if(this.getContext().initialized === false) {
            this.props.dispatch(getBetSummary(this.props.authentication.username));
        }

        this.props.dispatch(updateEthPrice());
    }

    changeTextInput(event) {
        this.props.dispatch(changeTextInput(event.target.name, event.target.value, "SUMMARY"));
    }

    getContext() {
        let { SUMMARY_CONTEXT={} } = this.props.pageContext;
        let { initialized=false, pendingBetSummary=false, pendingNav=false, data=[] } = SUMMARY_CONTEXT;

        return { initialized, pendingBetSummary, data, pendingNav };
    }

    viewProposal(keyUsername, keyProposal) {
        this.props.dispatch(viewProposalLoadAndNav(keyUsername, keyProposal));
    }

    render() {

        let context = this.getContext();
        let disabled = context.pendingNav;

        if(context.pendingBetSummary) {
                return (<div className="moveTop40 center"><img src={loading} className="loadIcon" alt="loading" /></div>);
        }
        else
        {
                return (
                        <div>
                        <div className="downArrow hide"></div>

                        <div className="sectionNoPadding">
                        <div className="titleCard">Bets where you're a participant</div>
                        <div className="summaryGap"></div>

                                {context.data.map((entry, index) => {
                                        if(entry && entry.hasOwnProperty("key")) {

                                            let blockchainData = null;
                                            if(entry.hasOwnProperty("finalize") && entry.finalize && entry.finalize.hasOwnProperty("betId")) {
                                                let betId = entry.finalize.betId;
                                                if(this.props.blockchainDataMap.hasOwnProperty(betId)) {
                                                    blockchainData = this.props.blockchainDataMap[betId];
                                                }
                                            }

                                            let keyUsername = entry.key.username;
                                            let keyProposal = entry.key.proposal;
                                            let combinedStatus = betStatusFromDatabase(keyUsername, keyProposal);

                                            return (<div key={index}><SummaryCard disabled={disabled} combinedStatus={combinedStatus} ethPrice={this.props.ethPrice} username={this.props.authentication.username} entry={entry} blockchainData={blockchainData} onClick={(e) => this.viewProposal(keyUsername, keyProposal)} /></div>);
                                        }

                                        return null;
                                })}
                        {/*
                        <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                                <div className="cardRow"><span className="strongText padTop20">VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Proposed<span className="squareAccepted"></span><span className="squareAwaiting"></span><span className="squareRejected"></span> &middot; 5.0 ETH (~$2250 USD) &middot; Sep 12, 2018</span></div>
                                <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                                <div className="cardRow red">Waiting on your response</div>
                        </div>
                        <div className="summaryGap"></div>

                        <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                                <div className="cardRow"><span className="strongText padTop20">VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Unfunded &middot; 5.0 ETH (~$2250 USD) &middot; Sep 12, 2018</span></div>
                                <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                                <div className="cardRow"><button className="btn">Deposit funds</button></div>
                        </div>
                        <div className="summaryGap"></div>

                        <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                                <div className="cardRow"><span className="strongText padTop20">VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Active &middot; 5.0 ETH (~$2250 USD) &middot; Sep 12, 2018</span></div>
                                <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                        </div>
                        <div className="summaryGap"></div>

                        <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                                <div className="cardRow"><span className="strongText padTop20">VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Canceled &middot; 5.0 ETH (~$2250 USD) &middot; Canceled by @ethgeek</span></div>
                        </div>
                        <div className="summaryGap"></div>

                        <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                                <div className="cardRow"><span className="strongText padTop20">VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Resolved &middot; 5.0 ETH (~$2250 USD) &middot; Won by @maimedprisoner</span></div>
                                <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                                <div className="cardRow"><button className="btn">Withdraw funds</button></div>
                        </div>
                        <div className="summaryGap"></div>

                        <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                                <div className="cardRow"><span className="strongText padTop20">Arbitrating @maimedprisoner VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Proposed<span className="squareAccepted"></span><span className="squareAwaiting"></span><span className="squareRejected"></span> &middot; 5.0 ETH (~$2250 USD) &middot; Sep 12, 2018</span></div>
                                <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                                <div className="cardRow red">Waiting on your response</div>
                        </div>
                        <div className="summaryGap"></div>

                        <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                                <div className="cardRow"><span className="strongText padTop20">@maimedprisoner VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Proposed &middot; 5.0 ETH (~$2250 USD)</span></div>
                                <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                        </div>
                        <div className="summaryGap"></div>

                        <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                                <div className="cardRow"><span className="strongText padTop20">@maimedprisoner VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Proposed &middot; 5.0 ETH (~$2250 USD)</span></div>
                                <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                        </div>
                        <div className="summaryGap"></div>

                        <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                                <div className="cardRow"><span className="strongText padTop20">@maimedprisoner VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Proposed &middot; 5.0 ETH (~$2250 USD)</span></div>
                                <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                        </div>
                        <div className="summaryGap"></div>
                        */}

                        </div>
                </div>
                );
        }
    }
  }
  
  export default connect(stateMap)(Summary);



// WEBPACK FOOTER //
// ./src/components/Summary.js